import { render, staticRenderFns } from "./AccordionContent2.vue?vue&type=template&id=c9024d9a&scoped=true"
import script from "./AccordionContent2.vue?vue&type=script&lang=js"
export * from "./AccordionContent2.vue?vue&type=script&lang=js"
import style0 from "./AccordionContent2.vue?vue&type=style&index=0&id=c9024d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9024d9a",
  null
  
)

export default component.exports